// Xortec contact + legal data
export const COMPANY = {
  name: "Xortec GmbH",
  street: "Berner Str. 79",
  zip: "60437",
  city: "Frankfurt am Main",
  country: "Deutschland",
  phone: "+49 69 5069886 0",
  phoneHref: "+496950698860",
  fax: "+49 69 5069886 29",
  email: "vertrieb@xortec.de",
  emailHref: "mailto:vertrieb@xortec.de",
  ceo: "Michael Schaller",
  register: "Frankfurt am Main",
  registerNumber: "HRB 79237",
  vatId: "DE252844047",
  weee: "DE 52527592",
  website: "www.xortec.de",
};
